import Switch from '@mui/material/Switch';

import { useNotificationPreferences } from 'hooks/useNotificationPreferences';

interface NotificationListItemProps {
  userID: string;
  deviceID: string;
}

export const NotificationDeviceSwitch = ({
  userID,
  deviceID,
}: NotificationListItemProps): JSX.Element => {
  const { handleSubmitDevice, checkedHubStatus, deviceUpdateLoading } =
    useNotificationPreferences({ userID, deviceID });

  return (
    <Switch
      onClick={(e) => e.stopPropagation()}
      checked={checkedHubStatus}
      onChange={(e) => handleSubmitDevice(e.target.checked, deviceID)}
      color="primary"
      disabled={deviceUpdateLoading}
      data-testid="notification-device-switch"
    />
  );
};
